export default function generateId() {
    return new Date().getTime().toString();
}
